export const FILTER_ITEM = {
  country: {
    label: {
      vi: 'Quốc gia',
      en: 'Country',
    },
    listData: {
      pvn: {
        vi: 'Phim Việt Nam',
        en: 'Vietnamese film',
        value: 'pvn',
      },
      ptl: {
        vi: 'Phim Thái Lan',
        en: 'Thailand film',
        value: 'ptl',
      },
      phq: {
        vi: 'Phim Hàn Quốc',
        en: 'Korea film',
        value: 'phq',
      },
      pnb: {
        vi: 'Phim Nhật Bản',
        en: 'Japanese film',
        value: 'pnb',
      },
      pm: {
        vi: 'Phim Mỹ',
        en: 'United State film',
        value: 'pm',
      },
      pad: {
        vi: 'Phim Ấn Độ',
        en: 'Indian film',
        value: 'pad',
      },
      phk: {
        vi: 'Phim Hồng Kông',
        en: 'HongKong film',
        value: 'phk',
      },
      ptw: {
        vi: 'Phim Đài Loan',
        en: 'Taiwan film',
        value: 'ptw',
      },
    },
  },
  category: {
    label: {
      vi: 'Thể loại',
      en: 'Category',
    },
    listData: {
      phd: {
        vi: 'Phim Hành Động',
        en: 'Vietnamese film',
        value: 'phd',
      },
      ptc: {
        vi: 'Phim Tình Cảm',
        en: 'Thailand film',
        value: 'ptc',
      },
      pvt: {
        vi: 'Phim Viễn Tưởng',
        en: 'Korea film',
        value: 'pvt',
      },
      ph: {
        vi: 'Phim Hài',
        en: 'Japanese film',
        value: 'ph',
      },
      ptl: {
        vi: 'Phim Tâm Lý',
        en: 'United State film',
        value: 'ptl',
      },
      ptli: {
        vi: 'Phim Tài Liệu',
        en: 'Indian film',
        value: 'ptli',
      },
      phh: {
        vi: 'Phim Hoạt Hình',
        en: '',
        value: 'phh',
      },
      pct: {
        vi: 'Phim Cổ Trang',
        en: '',
        value: 'pct',
      },
      pkd: {
        vi: 'Phim Kinh Dị',
        en: '',
        value: 'pkd',
      },
      pvth: {
        vi: 'Phim Võ Thuật',
        en: '',
        value: 'pvth',
      },
    },
  },
  year: {
    label: {
      vi: 'Năm phát hành',
      en: 'Release year',
      value: 'pvn',
    },
    listData: {
      _2022: {
        vi: '2022',
        en: '2022',
        value: '2022',
      },
      _2021: {
        vi: '2021',
        en: '2021',
        value: '2021',
      },
      _2020: {
        vi: '2020',
        en: '2020',
        value: '2020',
      },
      _2019: {
        vi: '2019',
        en: '2019',
        value: '2019',
      },
      _2018: {
        vi: '2018',
        en: '2018',
        value: '2018',
      },
      _2017: {
        vi: '2017',
        en: '2017',
        value: '2017',
      },
      _2016: {
        vi: '2016',
        en: '2016',
        value: '2016',
      },
      _2015: {
        vi: '2015',
        en: '2015',
        value: '2015',
      },
      _2014: {
        vi: '2014',
        en: '2014',
        value: '2014',
      },
      _2013: {
        vi: '2013',
        en: '2013',
        value: '2013',
      },
      _2012: {
        vi: '2012',
        en: '2012',
        value: '2012',
      },
      _2011: {
        vi: '2011',
        en: '2011',
        value: '2011',
      },
      _2010: {
        vi: '2010',
        en: '2010',
        value: '2010',
      },
      etc: {
        vi: 'Trước 2010',
        en: 'Before 2010',
        value: 'etc',
      },
    },
  },
  filterFilm: {
    category: '',
    country: '',
    year: '',
    name:''
  }
};
